import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <footer className="footer-text">made in 💖 with Aritra</footer>
    </div>
  );
};
export default Footer;
